module.exports = __webpack_public_path__ + "img/auth-left-female.25ed849e.jpg";